import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { type WorkflowExecutionsResponse, workflowsAPI } from '../lib/workflowsApi';

export function useWorkflowExecutions(organizationId: string | undefined, limit = 20, offset = 0) {
  return useQuery<WorkflowExecutionsResponse>({
    queryKey: ['workflow-executions', organizationId, limit, offset],
    queryFn: async () => {
      if (!organizationId) throw new Error('Organization is required');
      const { data } = await workflowsAPI.getExecutions(organizationId, limit, offset);
      return data;
    },
    enabled: !!organizationId,
    placeholderData: keepPreviousData,
    refetchInterval: 30000,
    staleTime: 30000,
  });
}
